import './style.css';

import { toHeisei, diffOfDays, toHeiseiDate } from './js/heisei';
import { toTime } from "./js/time";

const dateElm = document.getElementById('heisei-date');
const timeElm = document.getElementById('heisei-time');
const countElm = document.getElementById('heisei-count');
const twitterShareButton = document.getElementById('twitter-share-button');

function setContent() {
  const heiseiDate = toHeiseiDate();
  const heiseiTime = toTime();
  const numberOfDaysElapsed = `平成${diffOfDays() + 1}日目`;

  dateElm.textContent = heiseiDate;
  timeElm.textContent = heiseiTime;
  countElm.textContent = numberOfDaysElapsed;

  const shareText = encodeURIComponent(`現在${heiseiDate}、${numberOfDaysElapsed}。「平成を生き続けるサイト」`);
  const hashTags = encodeURIComponent('平成を生き続ける');
  twitterShareButton.setAttribute('href',
    `https://twitter.com/intent/tweet?text=${shareText}&url=${location.href}&hashtags=${hashTags}`);
}

setContent();

setInterval(() => {
  setContent();
}, 1000);
